const normalized = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
const uses = {raw:['raw','cru'],frying:['frying','a poeler'],stuffing:['stuffing','a farcir'],sauce:['sauce','sauces'],pickling:['pickling','a mariner'],container:['containers','container','contenants','en pot','pots']};
const heats = {sweet:['sweet','doux (sans piquant)'],mild:['mild','peu piquant'],medium:['medium','moyennement piquant'],hot:['hot','fort'],superhot:['super hot','superhot','tres fort']};
const list = value => (Array.isArray(value) ? value : value ? [value] : []).map(normalized);
export function maturityDays(text) {
  const value=normalized(text);
  if(!/(transplant|repiquage|semis|sowing|direct sow)/.test(value)) return null;
  const match=value.match(/(\d{2,3})(?:\s*[–—-]|\s+a\s+)?\s*(\d{2,3})?\s*(?:days|jours)/);
  return match ? Number(match[2] || match[1]) : null;
}
export function selectSeeds(products, preferences) {
  return products.filter(product=>{
    if(!product.available) return false;
    if(preferences.use && !list(product.use).some(v=>uses[preferences.use]?.includes(v))) return false;
    if(preferences.heat && !list(product.heat).some(v=>heats[preferences.heat]?.includes(v))) return false;
    if(preferences.space==='container' && !list(product.use).some(v=>uses.container.includes(v))) return false;
    if(preferences.days) { const days=maturityDays(product.maturity); if(days===null || days>Number(preferences.days)) return false; }
    return true;
  });
}
if(typeof document !== 'undefined') {
  const root=document.querySelector('[data-cv-seed-finder]');
  if(root) {
    const fr=root.dataset.fr==='true', form=root.querySelector('form'), status=root.querySelector('.cv-finder-status'), results=root.querySelector('.cv-finder-results');
    const button=form.querySelector('button'); let catalogue;
    const preferenceKey='cv-seed-finder-preferences';
    try {
      const saved=JSON.parse(sessionStorage.getItem(preferenceKey));
      if(saved && typeof saved==='object')for(const key of ['use','heat','space','days']) {
        const field=form.elements[key];
        if([...field.options].some(option=>option.value===saved[key]))field.value=saved[key];
      }
    } catch (_) {}
    const readSaved=()=>{
      const value=JSON.parse(localStorage.getItem('sv-wishlist') || '[]');
      return Array.isArray(value)?value.filter(h=>typeof h==='string' && /^[a-z0-9-]+$/.test(h)):[];
    };
    const syncSaved=()=>{
      let saved=[];try{saved=readSaved();}catch(_){}
      for(const control of results.querySelectorAll('[data-cv-save]')) {
        const active=saved.includes(control.dataset.cvSave);control.setAttribute('aria-pressed',String(active));
        control.textContent=active?(fr?'Retirer des favoris':'Remove from saved seeds'):(fr?'Enregistrer sans compte':'Save without an account');
      }
    };
    window.addEventListener('sv:wishlist:change',syncSaved);
    window.addEventListener('storage',event=>{if(event.key==='sv-wishlist')syncSaved();});
    const el=(tag,text)=>{const node=document.createElement(tag);if(text)node.textContent=text;return node;};
    async function load() {
      const products=[], seen=new Set();
      for(let page=1;page<=50;page++) {
        const url=new URL(root.dataset.catalogue,location.origin);url.searchParams.set('view','cv-seed-finder-data');url.searchParams.set('page',String(page));
        const response=await fetch(url);if(!response.ok)throw new Error('fetch');
        const data=await response.json();if(!Array.isArray(data.products))throw new Error('shape');
        for(const p of data.products)if(!seen.has(p.handle)){seen.add(p.handle);products.push(p);}
        if(!data.next)return products;
        if(!data.products.length)throw new Error('pagination');
      }
      throw new Error('pagination');
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();button.disabled=true;status.textContent=fr?'Recherche de variétés…':'Finding varieties…';
      try {
        if(!catalogue)catalogue=await load();
        const prefs=Object.fromEntries(new FormData(form));
        try{sessionStorage.setItem(preferenceKey,JSON.stringify(prefs));}catch(_){}
        const matches=selectSeeds(catalogue,prefs), picks=matches.slice(0,3);
        results.replaceChildren();
        status.textContent=matches.length?(fr?`${picks.length} suggestion${picks.length > 1 ? 's' : ''} parmi ${matches.length} variété${matches.length > 1 ? 's' : ''} correspondant à vos choix.`:`${picks.length} suggestion${picks.length > 1 ? 's' : ''} from ${matches.length} matching ${matches.length === 1 ? 'variety' : 'varieties'}.`):(fr?'Aucune correspondance vérifiée. Essayez une autre utilisation ou élargissez vos critères.':'No verified matches. Try another cooking use or broaden your preferences.');
        for(const product of picks) {
          const article=el('article');
          if(product.image){const image=el('img');image.src=product.image;image.alt=product.title;image.loading='lazy';article.append(image);}
          article.append(el('h2',product.title),el('p',product.price));
          const reasons=el('ul');
          for(const [key,label] of [['use',fr?'Utilisation choisie':'Chosen cooking use'],['heat',fr?'Piquant choisi':'Chosen heat']])if(prefs[key])reasons.append(el('li',`${label}: ${form.elements[key].selectedOptions[0].textContent}`));
          if(prefs.space==='container')reasons.append(el('li',fr?'Indiquée pour culture en contenant.':'Tagged for container growing.'));
          if(prefs.days)reasons.append(el('li',fr?`Maturité consignée dans votre limite de ${prefs.days} jours.`:`Recorded maturity is within your ${prefs.days}-day window.`));
          if(!reasons.children.length)reasons.append(el('li',fr?'Disponible dans le catalogue. Précisez vos choix pour affiner les suggestions.':'Available in the catalogue. Refine your choices for more specific suggestions.'));
          article.append(reasons);
          if(product.maturity)article.append(el('p',(fr?'Maturité : ':'Maturity: ')+product.maturity));
          if(product.habit)article.append(el('p',product.habit));
          if(product.seasonNotes)article.append(el('p',product.seasonNotes));
          const link=el('a',fr?'Voir la variété et ses conseils':'View variety and growing guidance');link.href=product.url;article.append(link);
          const actions=el('div');actions.className='cv-finder-actions';
          const save=el('button');save.type='button';save.dataset.cvSave=product.handle;
          save.addEventListener('click',()=>{
            try {
              const saved=readSaved(),added=!saved.includes(product.handle);
              const next=added?[...new Set([...saved,product.handle])]:saved.filter(h=>h!==product.handle);
              localStorage.setItem('sv-wishlist',JSON.stringify(next));
              window.dispatchEvent(new CustomEvent('sv:wishlist:change',{detail:{list:next,handle:product.handle,added}}));
              status.textContent=added?(fr?'Variété enregistrée dans ce navigateur. Retrouvez-la dans vos semences enregistrées.':'Saved in this browser. Find it in your saved seeds.'):(fr?'Variété retirée de vos favoris.':'Removed from your saved seeds.');
            } catch(_) {status.textContent=fr?'Votre navigateur ne permet pas l’enregistrement. Gardez cette page ouverte ou ajoutez la variété à vos signets.':'Your browser could not save this choice. Keep this page open or bookmark the variety.';}
          });
          const compare=el('button');compare.type='button';compare.className='m-compare-button';compare.dataset.productHandle=product.handle;compare.setAttribute('aria-pressed','false');
          const compareText=el('span',fr?'Comparer':'Compare');compareText.className='m-compare-button-text';compare.append(compareText);
          actions.append(save,compare);article.append(actions);results.append(article);
        }
        syncSaved();
      } catch (_) {status.textContent=fr?'Le catalogue ne peut pas être chargé. Réessayez dans un instant.':'The catalogue could not be loaded. Please try again shortly.';}
      finally {button.disabled=false;}
    });
    try{if(sessionStorage.getItem(preferenceKey))form.requestSubmit();}catch(_){}
  }
}
